// import Header from "../Header";
// import { KuitanAgentName } from "../../atoms/KuitanAgentName";
// import { KuitanAgentSidebarMenu } from "../sidebar/KuitanAgentSidebarMenu";
//
//
// const KutanAgentHeader = () => {
//   return <Header name={<KuitanAgentName/>} sideBarMenu={<KuitanAgentSidebarMenu/>}/>
// };
// export default KutanAgentHeader;

import React from "react";
import ResponsiveHeader from "./ResponsiveHeader";
import { KuitanAgentName } from "../../atoms/KuitanAgentName";
import { KuitanAgentSidebarMenu } from "../sidebar/KuitanAgentSidebarMenu";
import { LogoutModal } from "../LogoutModal";

const KutanAgentHeader = () => {
    return (
        <ResponsiveHeader
            name={null}
            title="BLOCKs"
            navItems={[<LogoutModal key="logout" />]}
            sidebar={<KuitanAgentSidebarMenu />}
        />
    );
};

export default KutanAgentHeader;